import React from "react";

export function getValidString(val){
  if(Boolean(val)){
    return val
  }
  return ""
}

export function changeStockValue(val){
  if(val === null){
    return 0
  }
  return val
}

export function getShopNameString(value) {
    if(!Boolean(value) || value.length === 0){
      return '-'
    }

    return value
}

export function changeImageURL(url) {
    if (url) {
      return url.replace('http://shop1.phinf.naver.net', 'https://shop-phinf.pstatic.net');
    }
    return url;
}

export function getEtcList(str) {
  // let infos = str.split("$%")
  return str.split("$%").map((info)=> <p>{info}</p>)
}


export function getWarehouseRackCode (centerId, warehouseState) {
  if(warehouseState && warehouseState.data && warehouseState.data.results){
    for (let warehouse of warehouseState.data.results){
      if(warehouse.id === centerId){
        return warehouse.code
      }
    }
  }
}
export function getWarehouseCenterIdFromCode (centerCode, warehouseState) {
  if(warehouseState && warehouseState.data && warehouseState.data.results){
    for (let warehouse of warehouseState.data.results){
      if(warehouse.code === centerCode){
        return warehouse.id
      }
    }
  }
}

export function getWarehouseNameFromId (id, warehouseState) {
  // console.log('getWarehouseNameFromId ', id)
  if(warehouseState && warehouseState.data && warehouseState.data.results){
    for (let warehouse of warehouseState.data.results){
      if(warehouse.id === id){
        return warehouse.name
      }
    }
  }
  return ''
}

export const getCenterStock = (stock) => {
  if(stock){
    return getCleanStockValue(changeStockValue(stock.center_stock) + changeStockValue(stock.naver_stock) + changeStockValue(stock.coupang_stock) + changeStockValue(stock.out_stock))
  }
  return 0
}

export function getRecentExpireDate (product, centerId) {
  for(let stock of product.stocks){
    if(stock.center_id === centerId){
      if(getCenterStock(stock) > 0 && stock.expire_dates != null){
        return stock.expire_dates.split(',')[0]
      }
    }
  }
  return null
}

export function getRackCodeByCenterId (centerId, warehouseState, rackCode) {
  if(warehouseState && warehouseState.data && warehouseState.data.results && Boolean(rackCode)){
    let results
    let rackCodes = rackCode.split(',')
    if(centerId === 1){
      results = rackCodes.filter((c)=> {
        for(let warehouse of warehouseState.data.results){
          if(warehouse.code !== 'S' && c.startsWith(warehouse.code)){
            return false;
          }
        }
        return true;
      })
    }else{
      let centerCode = getWarehouseRackCode(centerId, warehouseState)

      results = rackCodes.filter((c)=> c.startsWith(centerCode))

    }

    return results.join(',');
  }

  return '';

}


export function getWarehouseColor (centerId, warehouses) {
  if(warehouses){
    for (let warehouse of warehouses){
      // console.log(warehouse)
      if(warehouse.id === centerId){
        return '#' + warehouse.color;
      }
    }
  }
  return '#ffffff';
}

export function getWarehouseName(centerId, warehouseState) {
  if(warehouseState && warehouseState.data && warehouseState.data.results){
    for (let warehouse of warehouseState.data.results){
      if(warehouse.id === centerId){
        return warehouse.name;
      }
    }
  }
  return '?';
}

// export function getWarehouseName(centerId, warehouses) {
//   if(warehouses){
//     for (let warehouse of warehouses){
//       if(warehouse.id === centerId){
//         return warehouse.name;
//       }
//     }
//   }
//   return '?';
// }

export function getHistoryValues(input, expectedCount) {
  try{
    return input.split('/')
  }catch (e) {
    // console.log('error to getHistoryValues ', input)
    return new Array(expectedCount).fill('0');
  }

}

export function getCleanStockValue(value) {
  if(Number.isInteger(value)){
    return value
  }

  return value.toFixed(1)
}


export function getRecvCenterName(row, warehouseState) {
  if(row && row.recv_center) {
    return getWarehouseName(row.recv_center, warehouseState)
    // switch (row.recv_center) {
    //   case 1:
    //     return "서초"
    //   case 2:
    //     return "역삼"
    // }
  }else if(row.receiver_level){
    switch (row.receiver_level) {
      case 200:
        return "서초"
      case 201:
        return "역삼"
    }
  }

  return "?"
}


export function getMultilineTextToHtml (txt) {
    let text = String(txt).split("\n");
    let resultTag = '<div style="text-align:center">';
    for (let i = 0; i < text.length; i++) {
      resultTag += text[i].toLocaleString('ko-KR');
      if (i === text.length - 1) break;
      resultTag += '<br/>';
    }
    resultTag += '</div>';
    //    console.log("RET_TAG:", resultTag);
    return (resultTag);
  }